import { Locale } from '@flysas-tech/book-value-stream-models';
import { getLocale } from 'i18n';
import { LanguageCode, LANGUAGE_CODES, reverseLanguageCode } from 'shared';

const customerServiceUrlMap: Record<LanguageCode, string> = {
  [LANGUAGE_CODES.NO_NO]: 'https://www.sas.no/kundeservice/kontakt/',
  [LANGUAGE_CODES.NB_NO]: 'https://www.sas.no/kundeservice/kontakt/',
  [LANGUAGE_CODES.SV_SE]: 'https://www.sas.se/kundservice/kontakt/',
  [LANGUAGE_CODES.DA_DK]: 'https://www.sas.dk/kundeservice/kontakt/',
  [LANGUAGE_CODES.EN_FI]: 'https://www.sas.fi/en/customer-service/contact/',
  [LANGUAGE_CODES.EN_BE]: 'https://www.flysas.com/be-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_CA]: 'https://www.flysas.com/ca-en/customer-service/contact/',
  [LANGUAGE_CODES.FR_CA]: 'https://www.flysas.com/ca-fr/service-client/contact/',
  [LANGUAGE_CODES.ZH_CH]: 'https://www.flysas.com/cn-zh/customer-service/contact/',
  [LANGUAGE_CODES.ZH_CN]: 'https://www.flysas.com/cn-zh/customer-service/contact/',
  [LANGUAGE_CODES.FR_FR]: 'https://www.flysas.com/fr-fr/service-client/contact/',
  [LANGUAGE_CODES.DE_DE]: 'https://www.flysas.com/de-de/kundenservice/kontakt/',
  [LANGUAGE_CODES.EN_DE]: 'https://www.flysas.com/de-de/kundenservice/kontakt/',
  [LANGUAGE_CODES.EN_IE]: 'https://www.flysas.com/ie-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_IT]: 'https://www.flysas.com/it-en/customer-service/contact/',
  [LANGUAGE_CODES.JA_JP]: 'https://www.flysas.com/jp-ja/customer-service/contact/',
  [LANGUAGE_CODES.EN_NL]: 'https://www.flysas.com/nl-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_PL]: 'https://www.flysas.com/pl-en/customer-service/contact/',
  [LANGUAGE_CODES.ES_ES]: 'https://www.flysas.com/es-es/servicio-atencion-al-cliente/contacto/',
  [LANGUAGE_CODES.DE_CH]: 'https://www.flysas.com/ch-de/kundenservice/kontakt/',
  [LANGUAGE_CODES.FR_CH]: 'https://www.flysas.com/ch-fr/service-client/contact/',
  [LANGUAGE_CODES.EN_TH]: 'https://www.flysas.com/th-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_GB]: 'https://www.flysas.com/gb-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_HK]: 'https://www.flysas.com/hk-en/customer-service/contact/',
  [LANGUAGE_CODES.EN]: 'https://www.flysas.com/gb-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_LU]: 'https://www.flysas.com/gb-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_CH]: 'https://www.flysas.com/gb-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_AU]: 'https://www.flysas.com/gb-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_US]: 'https://www.flysas.com/us-en/customer-service/contact/',
  [LANGUAGE_CODES.EN_KR]: 'https://www.flysas.com/kr-en/customer-service/contact/',
  [LANGUAGE_CODES.KO_KR]: 'https://www.flysas.com/kr-ko/customer-service/contact/',
  [LANGUAGE_CODES.EN_RU]: 'https://www.flysas.com/gb-en/customer-service/contact/',
};

export const getCustomerServiceUrl = () => {
  const customerServiceUrl = customerServiceUrlMap[getLocale()];

  return customerServiceUrl ?? 'https://www.flysas.com/en/customer-service/contact/';
};

const conditionsOfCarriageUrlMap: Record<LanguageCode, string> = {
  [LANGUAGE_CODES.NO_NO]: 'https://www.sas.no/juridisk-info/vilkar-for-befordring/',
  [LANGUAGE_CODES.NB_NO]: 'https://www.sas.no/juridisk-info/vilkar-for-befordring/',
  [LANGUAGE_CODES.SV_SE]: 'https://www.sas.se/juridisk-information/transportvillkor/',
  [LANGUAGE_CODES.DA_DK]: 'https://www.sas.dk/juridiske-oplysninger/befordringsbetingelser/',
  [LANGUAGE_CODES.EN_FI]: 'https://www.sas.fi/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_BE]: 'https://www.flysas.com/be-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_CA]: 'https://www.flysas.com/ca-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.FR_CA]: 'https://www.flysas.com/ca-fr/infos-legales/conditions-de-transport/',
  [LANGUAGE_CODES.ZH_CH]: 'https://www.flysas.com/cn-zh/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.ZH_CN]: 'https://www.flysas.com/cn-zh/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.FR_FR]: 'https://www.flysas.com/fr-fr/infos-legales/conditions-de-transport/',
  [LANGUAGE_CODES.DE_DE]: 'https://www.flysas.com/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_DE]: 'https://www.flysas.com/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_CH]: 'https://www.flysas.com/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_LU]: 'https://www.flysas.com/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_HK]: 'https://www.flysas.com/hk-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_IE]: 'https://www.flysas.com/ie-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_IT]: 'https://www.flysas.com/it-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.JA_JP]: 'https://www.flysas.com/jp-ja/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_NL]: 'https://www.flysas.com/nl-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_PL]: 'https://www.flysas.com/pl-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.ES_ES]: 'https://www.flysas.com/es-es/informacion-legal/condiciones-de-transporte/',
  [LANGUAGE_CODES.DE_CH]: 'https://www.flysas.com/en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.FR_CH]: 'https://www.flysas.com/ch-fr/infos-legales/conditions-de-transport/',
  [LANGUAGE_CODES.EN_TH]: 'https://www.flysas.com/th-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_GB]: 'https://www.flysas.com/gb-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN]: 'https://www.flysas.com/gb-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_AU]: 'https://www.flysas.com/gb-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_US]: 'https://www.flysas.com/us-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_KR]: 'https://www.flysas.com/kr-en/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.KO_KR]: 'https://www.flysas.com/kr-ko/legal-info/conditions-of-carriage/',
  [LANGUAGE_CODES.EN_RU]: 'https://www.flysas.com/gb-en/legal-info/conditions-of-carriage/',
};

export const getConditionsOfCarriageUrl = (language?: LanguageCode) => {
  const customerServiceUrl = conditionsOfCarriageUrlMap[language ?? getLocale()];

  return customerServiceUrl ?? 'https://www.flysas.com/en/legal-info/conditions-of-carriage/';
};

const rebookingRulesUrlMap: Record<LanguageCode, string> = {
  [LANGUAGE_CODES.NO_NO]: 'https://www.sas.no/kundeservice/ombooking-endring-billett',
  [LANGUAGE_CODES.NB_NO]: 'https://www.sas.no/kundeservice/ombooking-endring-billett',
  [LANGUAGE_CODES.SV_SE]: 'https://www.sas.se/kundservice/boka-om-andra-biljett',
  [LANGUAGE_CODES.DA_DK]: 'https://www.sas.dk/kundeservice/ombooke-andre-billet',
  [LANGUAGE_CODES.EN_FI]: 'https://www.sas.fi/en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_BE]: 'https://www.flysas.com/be-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_CA]: 'https://www.flysas.com/ca-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.FR_CA]: 'https://www.flysas.com/ca-fr/service-client/nouvelle-reservation-modification-billet',
  [LANGUAGE_CODES.ZH_CH]: 'https://www.flysas.com/cn-zh/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.ZH_CN]: 'https://www.flysas.com/cn-zh/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.FR_FR]: 'https://www.flysas.com/fr-fr/service-client/nouvelle-reservation-modification-billet',
  [LANGUAGE_CODES.DE_DE]: 'https://www.flysas.com/de-de/kundenservice/ticketumtausch-erstattung',
  [LANGUAGE_CODES.EN_DE]: 'https://www.flysas.com/de-de/kundenservice/ticketumtausch-erstattung',
  [LANGUAGE_CODES.EN_CH]: 'https://www.flysas.com/de-de/kundenservice/ticketumtausch-erstattung',
  [LANGUAGE_CODES.EN_LU]: 'https://www.flysas.com/en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_HK]: 'https://www.flysas.com/hk-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_IE]: 'https://www.flysas.com/ie-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_IT]: 'https://www.flysas.com/it-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.JA_JP]: 'https://www.flysas.com/jp-ja/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_NL]: 'https://www.flysas.com/nl-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_PL]: 'https://www.flysas.com/pl-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.ES_ES]: 'https://www.flysas.com/es-es/servicio-atencion-al-cliente/cambiar-reserva-o-billete',
  [LANGUAGE_CODES.DE_CH]: 'https://www.flysas.com/ch-de/kundenservice/ticketumtausch-erstattung',
  [LANGUAGE_CODES.FR_CH]: 'https://www.flysas.com/ch-fr/service-client/nouvelle-reservation-modification-billet',
  [LANGUAGE_CODES.EN_TH]: 'https://www.flysas.com/th-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_GB]: 'https://www.flysas.com/gb-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN]: 'https://www.flysas.com/en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_AU]: 'https://www.flysas.com/gb-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_US]: 'https://www.flysas.com/us-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_KR]: 'https://www.flysas.com/kr-en/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.KO_KR]: 'https://www.flysas.com/kr-ko/customer-service/rebook-change-ticket',
  [LANGUAGE_CODES.EN_RU]: 'https://www.flysas.com/gb-en/customer-service/rebook-change-ticket',
};

export const getRebookingRulesUrl = () => {
  const rebookingRulesUrl = rebookingRulesUrlMap[getLocale()];

  return rebookingRulesUrl ?? 'https://www.flysas.com/en/customer-service/rebook-change-ticket/';
};

export const getTermsAndConditionsUrl = (_locale?: Locale) => {
  const pathname = 'misc/terms-and-conditions/terms-and-conditions-rev-cpy.content.html';

  if (location.hostname === 'localhost') {
    return `https://www.flysas.com/${pathname}`;
  }

  const topLevelDomain = location.hostname.split('.').pop();

  if (topLevelDomain !== 'com') {
    return `${location.origin}/${pathname}`;
  }

  let locale = _locale ?? getLocale();
  locale = locale === Locale.DE_DE ? Locale.EN_DE : locale;
  locale = locale === Locale.DE_CH ? Locale.EN_CH : locale;

  return `${location.origin}/${reverseLanguageCode(locale)}/${pathname}`;
};

export const getSportSignUpUrl = () => {
  const sportsInfoUrls: Partial<Record<LanguageCode, string>> = {
    [LANGUAGE_CODES.NO_NO]: 'https://www.sas.no/reiseinfo/sportsbillett/sport-signup/',
    [LANGUAGE_CODES.SV_SE]: 'https://www.sas.se//reseinfo/sportbiljetter/sport-signup/',
    [LANGUAGE_CODES.DA_DK]: 'https://www.sas.dk/rejseinfo/sportsbilletter/sport-signup/',
  };

  const lang = getLocale();
  const sportSignupUrl = sportsInfoUrls[lang];
  return sportSignupUrl ?? 'https://www.flysas.com/en/travel-info/sports-tickets/sport-signup/';
};
